export default __webpack_public_path__ + "static/media/landing_video_data_2.dd676cb9.jpg";